import { FC } from 'react';
import { useField } from 'formik';
import Select, { SelectProps, Value } from '@/components/ui/Select/Select';

interface FormikSelectProps extends Omit<SelectProps, 'value' | 'onChange' | 'errorMessage' | 'touched'> {
	name: string;
	onValueChange?: (value: Value) => void;
}

const FormikSelect: FC<FormikSelectProps> = ({ name, options, onValueChange, ...props }) => {
	const [{ value }, { error, touched }, { setValue }] = useField(name);

	return (
		<Select
			{...props}
			options={options}
			value={value}
			onChange={newValue => {
				setValue(newValue);
				onValueChange?.(newValue);
			}}
			errorMessage={error}
			touched={touched}
			name={name}
		/>
	);
};

export default FormikSelect;
